import React from 'react';
import { Layout, Card, Row, Col, Typography } from 'antd';
import { 
    DollarOutlined, 
    TeamOutlined, 
    TrophyOutlined, 
    BarChartOutlined,
    ArrowRightOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";

const { Content } = Layout;
const { Title: AntTitle, Text } = Typography;

const ReportsDashboard = () => {
    const navigate = useNavigate();

    const menuItems = [
        {
            title: 'Financial Reports',
            description: 'Revenue analysis, invoice stats, and financial trends.',
            icon: <DollarOutlined style={{ fontSize: 48, color: '#52c41a' }} />,
            path: '/reports/financial'
        },
        {
            title: 'Member Analytics',
            description: 'Member growth, status distribution, and registration insights.',
            icon: <TeamOutlined style={{ fontSize: 48, color: '#1890ff' }} />,
            path: '/reports/members'
        },
        {
            title: 'Trainer Reports',
            description: 'Trainer workload, assignments, and activity levels.',
            icon: <TrophyOutlined style={{ fontSize: 48, color: '#faad14' }} />,
            path: '/reports/trainers'
        }
    ];

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Headerdiv />
            <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
                <div style={{ textAlign: 'center', marginBottom: 40 }}>
                    <AntTitle level={2}>
                        <BarChartOutlined /> Reports & Analytics
                    </AntTitle>
                    <Text type="secondary">Select a report category to view detailed analytics</Text>
                </div>

                <Row gutter={[24, 24]} justify="center">
                    {menuItems.map((item, index) => (
                        <Col xs={24} sm={12} md={8} key={index}>
                            <Card 
                                hoverable 
                                style={{ textAlign: 'center', height: '100%' }}
                                onClick={() => navigate(item.path)}
                                actions={[<ArrowRightOutlined key="arrow" />]}
                            >
                                <div style={{ marginBottom: 20 }}>
                                    {item.icon}
                                </div>
                                <AntTitle level={4}>{item.title}</AntTitle>
                                <Text type="secondary">{item.description}</Text>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
            <Footerdiv />
        </Layout>
    );
};

export default ReportsDashboard;
